import { render, staticRenderFns } from "./taxAgainLaw.vue?vue&type=template&id=0e511d15&scoped=true&"
import script from "./taxAgainLaw.vue?vue&type=script&lang=js&"
export * from "./taxAgainLaw.vue?vue&type=script&lang=js&"
import style0 from "./taxAgainLaw.vue?vue&type=style&index=0&id=0e511d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e511d15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e511d15')) {
      api.createRecord('0e511d15', component.options)
    } else {
      api.reload('0e511d15', component.options)
    }
    module.hot.accept("./taxAgainLaw.vue?vue&type=template&id=0e511d15&scoped=true&", function () {
      api.rerender('0e511d15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/taxAgainLaw.vue"
export default component.exports